export const POOL_ADDRESSES_PROVIDER = '0x16085E000eAC286aa503326cBcEe4564268a7F8f';
export const POOL = '0x6447c4390457CaD03Ec1BaA4254CEe1A3D9e1Bbd';
export const UI_POOL_DATA_PROVIDER = '0x6Ab39f4e9F494733893Ca90212558e55C7196012';
export const WALLET_BALANCE_PROVIDER = '0x1c46f275860C177BB535bA570A23c2fB47dEc33F';
export const WETH_GATEWAY = '0xeFc4c155B6E999eCE695846df29Fab6C2A1Cb01D';
export const FALLBACK_FLASHLOAN_PROVIDER = '0xCf2a1D11Aa329335D86BD02974a97b48E446Aa05';
export const PREFERRED_FLASHLOAN_PROVIDERS = [];
export const ASSET_CONVERTER = '0x07B99965dBEdf38322ADFe48623e042Aa0656283';
export const CHAIN_ID = 1;
